/** Figma `TextInput`(Components, 31:664)의 축 */
export type TextInputShape = 'default' | 'pill' | 'plain';
export type TextInputSize = 'sm' | 'md' | 'lg';
export type TextInputStatus = 'default' | 'init';

/** 높이: sm 32 · md 40 · lg 48 (`size/control/*`). 글자는 모든 크기가 `body` */
export const SIZE_CLASS: Record<TextInputSize, string> = {
  sm: 'h-(--size-control-sm)',
  md: 'h-(--size-control-md)',
  lg: 'h-(--size-control-lg)',
};

/** 모양: 모서리 · 좌우 여백. plain 은 테두리 · 면 · 여백이 없다(다른 상자 안에 넣어 쓴다) */
export const SHAPE_CLASS: Record<TextInputShape, string> = {
  default: 'rounded-md px-4',
  pill: 'rounded-4xl px-5',
  plain: 'rounded-md px-0',
};

/** state=default (+ focus 는 CSS `focus-within:`) */
export const DEFAULT_STATE_CLASS: Record<TextInputShape, string> = {
  default:
    'border border-border-input bg-bg-surface focus-within:border-2 focus-within:border-border-input-focus',
  pill: 'border border-border-input bg-bg-surface focus-within:border-2 focus-within:border-border-input-focus',
  // Figma 의 plain 은 포커스 모양이 없다. 키보드 사용자를 위해 공통 포커스 링을 둔다(fe-rules 2절)
  plain:
    'border-0 focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-border-focus',
};

/** state=error (`invalid`) — 모든 모양이 2px 위험 테두리 */
export const INVALID_STATE_CLASS: Record<TextInputShape, string> = {
  default: 'border-2 border-border-danger bg-bg-surface',
  pill: 'border-2 border-border-danger bg-bg-surface',
  plain: 'border-2 border-border-danger',
};

/** state=disabled */
export const DISABLED_STATE_CLASS: Record<TextInputShape, string> = {
  default: 'border border-border-default bg-bg-disabled',
  pill: 'border border-border-default bg-bg-disabled',
  plain: 'border-0',
};
